var Backbone = bookedby.deps != null ? bookedby.deps.Backbone : global.Backbone;
var $ = bookedby.deps != null ? bookedby.deps.$ : global.$;

Backbone.Epoxy.binding.addHandler("datepicker", {
  init: function( $element, value, bindings, context ) {
    //console.log('will init...');
    //TODO:: proper config for this
    $element.datepicker({
      minDate: 0,
      dateFormat: 'MM d, yy',
      constrainInput: true,
      beforeShowDay: function(date) {
        if (!bookedby.app.scheduleManager) {
          return [true, '', null];
        }

        return bookedby.app.scheduleManager.isStoreOpen(date);
      }
    });
    $element.addClass('has-datepicker');
    $('#ui-datepicker-div').css('display', 'none'); //Hack to fix empty datepicker div displaying on init
  },


  get: function( $element, value, event ) {
    return $element.datepicker('getDate');
  },

  set: function( $element, value ) {
    $element.datepicker('setDate', value);
  },

  clean: function() {
    if (this.$el.hasClass('has-datepicker')) {
      try {
        this.$el.datepicker('destroy');
        this.$el.removeClass('has-datepicker');
      } catch (ex) {}
    }
  }
});

Backbone.Epoxy.binding.addHandler("datepickerMonthBirthday", {
  init: function($element, value, bindings, context) {
    $element.datepicker({
      changeMonth: true,
      changeYear: true,
      showButtonPanel: true,
      maxDate: 0,
      dateFormat: 'MM, yy',
      constrainInput: true,
      yearRange: moment().subtract(100, 'years').year() + ":" + moment().year(),
      onClose: function(dateText, inst) {
        $element.val(moment({
          years: inst.selectedYear,
          months: inst.selectedMonth,
          day: 1
        }).format('MMMM, YYYY'));

        $element.change();
      },
      beforeShow: function(input, inst) {
        inst.dpDiv.addClass('ui-datepicker-month')
      }
    });
    $element.addClass('has-monthpicker-birthdate');
    $('#ui-datepicker-div').css('display', 'none'); //Hack to fix empty datepicker div displaying on init
  },


  get: function($element, value, event) {
    return moment($element.val(), 'MMMM, YYYY').format('MM-DD-YYYY');
  },

  set: function($element, value) {
    if (value) {
      var birthdate = moment(value, 'MM-DD-YYYY');
      $element.datepicker('setDate', new Date(birthdate.year(), birthdate.month(), 1));
      $element.datepicker('option', 'defaultDate', new Date(birthdate.year(), birthdate.month(), 1));
      $element.val(moment(value, 'MM-DD-YYYY').format('MMMM, YYYY'));
    }
  },

  clean: function() {
    if (this.$el.hasClass('has-monthpicker-birthdate')) {
      try {
        this.$el.datepicker('destroy');
        this.$el.removeClass('has-monthpicker-birthdate');
      } catch (ex) {}
    }
  }
});

Backbone.Epoxy.binding.addHandler("monthpickerBirthday", {
  init: function($element, value, bindings, context) {
    $element.MonthPicker({
      maxDate: 0,
      MonthFormat: 'MM, yy',
      MinMonth: '-100y',
      MaxMonth: 0,
      Animation: 'none',
      Button: false,
      HideAnim: 'none',
      ShowOn: 'focus',
      OnAfterChooseMonth: function(selectedDate) {
        $element.change();
      }
    });
    $element.addClass('has-monthpicker-birthdate');
  },


  get: function($element, value, event) {
    if (!$element.val()) {
      return $element.val();
    }
    if (!moment($element.val(), 'MMMM, YYYY', true).isValid()) {
      return $element.val();
    }

    return moment($element.val(), 'MMMM, YYYY').format('MM-DD-YYYY');
  },

  set: function($element, value) {
    if (value) {
      if (!moment(value, 'MM-DD-YYYY', true).isValid()) {
        $element.val();
      } else {
        $element.val(moment(value, 'MM-DD-YYYY').format('MMMM, YYYY'));
      }
    }
  },

  clean: function() {
    if (this.$el.hasClass('has-monthpicker-birthdate')) {
      try {
        this.$el.MonthPicker.Destroy();
        this.$el.removeClass('has-monthpicker-birthdate');
      } catch (ex) {}
    }
  }
});

Backbone.Epoxy.binding.addHandler('autocompleteLocation', {

  init: function( $element, value, bindings, context ) {

    //NOTE:: canada gets shorter valid autocomplete length due to 3-digit postal codes being meaningful
    var minAutocompleteLength = (bookedby.staticData.storeGroupSettings.countryCode == 'CA') ? 3 : 5;

    function _renderItemData(ul, item) {
      return _renderItem(ul, item).data("ui-autocomplete-item", item);
    }

    function _renderItem(ul, item) {
      return $("<li>")
        .attr("role", "option")
        .attr("data-value", item.value)
        .append(item.label)
        .appendTo(ul);
    }

    $element.autocomplete({
      source: function( request, response ) {
        var handleQueryChangedDebounced = _.debounce(function() {
          bookedby.helpers.locationAutocomplete(request.term, response);
        }, 1000);

        handleQueryChangedDebounced();

      },
      minLength: minAutocompleteLength,
      select: function( event, ui ) {
        $("#geometryIdInput").val(ui.item.value);
        $( this).val(ui.item.label);
        $( this).trigger('change');

        return false;
      },

      messages: {
        noResults: '',
        results: function() {}
      },
      focus: function (event, ui) {
        this.value = ui.item.label;
        event.preventDefault();

        return false;
      },
      open: function() {
        $("#geometryIdInput").val('');
        $("#locationResults").attr("aria-expanded", true);
      },
      close: function() {
        $element.blur();
        $("#locationResults").attr("aria-expanded", false);
      },
      create: function(event, ui) {
        $(".ui-autocomplete").attr("role", "listbox");
      },
      appendTo: "#locationResults"
    })
      .data("ui-autocomplete")
      ._renderMenu = function(ul, items) {
        var that = this;
        var locationResultsInfo = $("#locationResultsInfo");
        if (!locationResultsInfo.length) {
          $("#locationResults").append("<div id='locationResultsInfo' class='visuallyHidden' role='status' aria-live='polite' />");
        }
        $("#locationResultsInfo").html(items.length.toString() + " results are available, use up and down arrow keys to navigate");
        $.each(items, function(index, item) {
          _renderItemData(ul, item);
        });
      }
  },

  get: function( $element, value, event ) {
    if ((event.type == 'keyup') && (event.keyCode != 13)) {
      return;
    }
    return $element.val();
  },

  set: function( $element, value ) {
    $element.focus();
    $element.val(value);
  },

  clean: function() {
    if ( this.$el.autocomplete) {
      this.$el.autocomplete('destroy');
    }
  }

});

Backbone.Epoxy.binding.addHandler('zipCodeSearchBinding', {

  init: function( $element, value, bindings, context ) { },

  get: function( $element ) {
    return $element.val();
  },

  set: function( $element, value ) {
    $element.focus();
    $element.val(value);
  },

  clean: function() { }
});

/**
 * Handler for general datepicker inputs.
 */

var yearPickerSelected = false;

Backbone.Epoxy.binding.addHandler("datepickerBirthdate", {
  init: function( $element, value, bindings, context ) {
    // Initialize the binding handler...
    var datepicker = $('#ui-datepicker-div');
    $element.datepicker({
       dateFormat: 'mm-dd-yy',
       constrainInput: true,
       changeYear: true,
      showOn: 'both',
      buttonImageOnly: true,
      buttonText: 'Open Calendar',
      dayNamesShort: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
      showButtonPanel: true,
      closeText: 'Close',
      onClose: removeAria,
      onChangeMonthYear: function(a) {
        if (yearPickerSelected) {
          dayTripper();
        }
      },
      beforeShow: function() {
         setTimeout(setupDayTripper, 1000);
      },
       maxDate: new Date(),
       yearRange: moment()._d.getFullYear() - 100 + ":" + moment()._d.getFullYear()
    });
    $element.addClass('has-datepicker-birthdate');
    datepicker.attr("role", "application");
    datepicker.attr("aria-label", "Choose a date");
    var trigger = $(".ui-datepicker-trigger");
    $("#profileInforBirthday").parent().append("<span tab-index=\"-1\" id=\"birthday-description\" aria-hidden=\"true\" class=\"hidden-block\">Insert your birthday date in format: MM-DD-YYYY</span>\n");
    $("#profileInforBirthday").attr("aria-describedby", "birthday-description");
    trigger.replaceWith("<span class='input-group-addon' aria-hidden='true'>" +
        "<a href=\"#\" class=\"ui-datepicker-trigger fa fa-calendar profile-datepicker\"></a>"
        + "</span>");
    datepicker.css('display', 'none'); //Hack to fix empty datepicker div displaying on init
    $element.focusin(function() {
      $element.val(global.bookedby.helpers.dateFormatFocus($element.val(), 'MMMM D, YYYY', 'MM-DD-YYYY', true, true));
    });
    $element.focusout(function() {
      $element.val(global.bookedby.helpers.dateFormatFocus($element.val(), 'MM-DD-YYYY', 'MMMM D, YYYY', true, false));
    });
  },

  get: function( $element, value, event ) {
    return global.bookedby.helpers.birthdateInternalFormat($element.val());
  },

  set: function( $element, value ) {
    var dateRaw = (''+value).replace(/\+1/g, '').replace(/\D/g, '');
    var dateFormatted = '';

    for (var i = 0; (i < dateRaw.length); i++) {
      dateFormatted += dateRaw[i];
      if ((dateFormatted.length == 2) || (dateFormatted.length == 5)) {
        dateFormatted += '-';
      }
    }
    dateFormatted = dateFormatted.substr(0, 10);

    $element.datepicker('setDate', global.bookedby.helpers.birthdateFormat(dateFormatted));
    $element.val(global.bookedby.helpers.birthdateFormat(dateFormatted));
  },

  clean: function() {
    if (this.$el.hasClass('has-datepicker-birthdate')) {
      try {
        this.$el.datepicker('destroy');
        this.$el.removeClass('has-datepicker-birthdate');
      } catch (ex) {}
    }
  }
});

function setupDayTripper() {
  $('.ui-datepicker-trigger').click(function () {
    dayTripper();
  })
}

function dayTripper() {
  yearPickerSelected = false;
    setTimeout(function () {
      var today = $('.ui-datepicker-today a')[0];

      if (!today) {
        today = $('.ui-state-active')[0] ||
            $('.ui-state-default')[0];
      }


      // Hide the entire page (except the date picker)
      // from screen readers to prevent document navigation
      // (by headings, etc.) while the popup is open
      $("main").attr('id','dp-container');
      $("#dp-container").attr('aria-hidden','true');
      $("#skipnav").attr('aria-hidden','true');

      // Hide the "today" button because it doesn't do what
      // you think it supposed to do
      $(".ui-datepicker-current").hide();
      var table = $(".ui-datepicker-calendar");
      table.attr("role", "grid");
      table.attr("aria-readonly", "true");
      $(".ui-datepicker-calendar th").attr("role", "columnheader");
      remapTable();

      $(".ui-datepicker-calendar tr").attr("role", "row");
      $(".ui-datepicker-calendar td").attr("role", "gridcell");
      today.focus();
      datePickHandler();
      $(document).on('click', '#ui-datepicker-div .ui-datepicker-close', function () {
        closeCalendar();
      });
    }, 0);
}

function datePickHandler() {
  var activeDate;
  var container = document.getElementById('ui-datepicker-div');
  var input = document.getElementById('profileInforBirthday');

  if (!container || !input) {
    return;
  }

  // $(container).find('table').first().attr('role', 'grid');

  container.setAttribute('role', 'application');
  container.setAttribute('aria-label', 'Calendar view date-picker');

  // the top controls:
  var prev = $('.ui-datepicker-prev', container)[0],
      next = $('.ui-datepicker-next', container)[0];


// This is the line that needs to be fixed for use on pages with base URL set in head
  next.href = 'javascript:void(0)';
  prev.href = 'javascript:void(0)';

  next.setAttribute('role', 'button');
  next.removeAttribute('title');
  prev.setAttribute('role', 'button');
  prev.removeAttribute('title');
  prev.setAttribute("href", "");
  next.setAttribute("href", "");

  appendOffscreenMonthText(next);
  appendOffscreenMonthText(prev);

  // delegation won't work here for whatever reason, so we are
  // forced to attach individual click listeners to the prev /
  // next month buttons each time they are added to the DOM
  $(next).on('click', handleNextClicks);
  $(prev).on('click', handlePrevClicks);

  monthDayYearText();
  var containerKeydownQuantity = $._data($("#ui-datepicker-div").get(0), 'events').keydown;
  var canSetup = true;
  if (containerKeydownQuantity)
    canSetup = containerKeydownQuantity.length < 1;
  if (canSetup)
  $(container).on('keydown', function calendarKeyboardListener(keyVent) {
    var which = keyVent.which;
    var target = keyVent.target;
    var dateCurrent = getCurrentDate(container);
    if (!dateCurrent) {
      dateCurrent = $('a.ui-state-default')[0];
      setHighlightState(dateCurrent, container);
    }

    if (27 === which) {
      keyVent.stopPropagation();
      return closeCalendar();
    } else if (which === 9 && keyVent.shiftKey) { // SHIFT + TAB
      keyVent.preventDefault();
      yearPickerSelected = false;
      if ($(target).hasClass('ui-datepicker-close')) { // close button
        activeDate = $('.ui-state-highlight') ||
          $('.ui-state-active')[0];
        if (activeDate) {
          activeDate.focus();
        }
      } else if ($(target).hasClass('ui-state-default')) { // a date link
        $('.ui-datepicker-next')[0].focus();
      }else if ($(target).hasClass('ui-datepicker-next')) { // the next link
        $(".ui-datepicker-prev")[0].focus();
      } else if ($(target).hasClass('ui-datepicker-prev')) { // the prev link
        yearPickerSelected = true;
        $(".ui-datepicker-year")[0].focus();
      } else if ($(target).hasClass("ui-datepicker-year")) {
        $('.ui-datepicker-close')[0].focus();
      }
    } else if (which === 9) { // TAB
      keyVent.preventDefault();
      yearPickerSelected = false;
      if ($(target).hasClass("ui-datepicker-close")) {
        yearPickerSelected = true;
        $(".ui-datepicker-year")[0].focus();
      } else if ($(target).hasClass("ui-datepicker-year")) {
        $(".ui-datepicker-prev")[0].focus();
      } else if ($(target).hasClass("ui-datepicker-prev")) {
        $(".ui-datepicker-next")[0].focus();
      } else if ($(target).hasClass("ui-datepicker-next")) {
        activeDate = $('.ui-state-highlight') ||
          $('.ui-state-active')[0];
        if (activeDate) {
          activeDate.focus();
        }
      } else if ($(target).hasClass("ui-state-default")) {
        $(".ui-datepicker-close")[0].focus();
      }
    } else if (which === 37) { // LEFT arrow key
      // if we're on a date link...
      if (!$(target).hasClass('ui-datepicker-close') && $(target).hasClass('ui-state-default')) {
        keyVent.preventDefault();
        previousDay(target);
      }
    } else if (which === 39) { // RIGHT arrow key
      // if we're on a date link...
      if (!$(target).hasClass('ui-datepicker-close') && $(target).hasClass('ui-state-default')) {
        keyVent.preventDefault();
        nextDay(target);
      }
    } else if (which === 38) { // UP arrow key
      if (!$(target).hasClass('ui-datepicker-close') && $(target).hasClass('ui-state-default')) {
        keyVent.preventDefault();
        upHandler(target, container, prev);
      }
    } else if (which === 40) { // DOWN arrow key
      if (!$(target).hasClass('ui-datepicker-close') && $(target).hasClass('ui-state-default')) {
        keyVent.preventDefault();
        downHandler(target, container, next);
      }
    } else if (which === 13) { // ENTER
      if ($(".ui-datepicker.year").is(":focus")) {
        handleYearSelect();
      } else if ($(target).hasClass('ui-state-default')) {
        setTimeout(function () {
          closeCalendar();
        }, 100);
      } else if ($(target).hasClass('ui-datepicker-prev')) {
        handlePrevClicks();
      } else if ($(target).hasClass('ui-datepicker-next')) {
        handleNextClicks();
      } else if ($(target).hasClass('ui-datepicker-year')) {
        handleYearSelect();
      }
    } else if (32 === which) { //  --SPACE--
      keyVent.preventDefault();
      keyVent.stopPropagation();
      $(target).click();
      if ($(target).hasClass('ui-datepicker-prev') || $(target).hasClass("ui-datepicker-next") || $(target).hasClass("ui-datepicker-close")) {
        if ($(target).hasClass('ui-datepicker-prev')) {
          handlePrevClicks();
        } else if ($(target).hasClass('ui-datepicker-next')) {
          handleNextClicks();
        } else {
          setTimeout(function () {
            closeCalendar();
          }, 100);
        }
      }
    } else if (33 === which) { // PAGE UP
      moveOneMonth(target, 'prev');
    } else if (34 === which) { // PAGE DOWN
      moveOneMonth(target, 'next');
    } else if (36 === which) { // HOME
      var firstOfMonth = $(target).closest('tbody').find('.ui-state-default')[0];
      if (firstOfMonth) {
        firstOfMonth.focus();
        setHighlightState(firstOfMonth, $('#ui-datepicker-div')[0]);
      }
    } else if (35 === which) { // END
      var $daysOfMonth = $(target).closest('tbody').find('.ui-state-default');
      var lastDay = $daysOfMonth[$daysOfMonth.length - 1];
      if (lastDay) {
        lastDay.focus();
        setHighlightState(lastDay, $('#ui-datepicker-div')[0]);
      }
    }
    $(".ui-datepicker-current").hide();
  });
}

function remapTable() {
  var spans = $(".ui-datepicker-calendar th span");
  spans.map(function (index, span) {
    $(span).attr("aria-label", span.title);
  });
  $(".ui-datepicker-calendar td").attr("aria-selected", false);
  $(".ui-datepicker-calendar a").attr("href", "javascript:void(0)");
  var selected = $(".ui-state-active");
  selected.parent().attr("aria-selected", true);
  setTimeout(function() {
    if (selected.attr("aria-label"))
      if (selected.attr("aria-label").indexOf("Selected") === -1)
        selected.attr("aria-label", selected.attr("aria-label") + " Selected");
  }, 300);
}

function closeCalendar() {
  var container = $('#ui-datepicker-div');
  $(container).off('keydown');
  var input = $('#profileInforBirthday')[0];
  $(input).datepicker('hide');

  input.focus();
}

function removeAria() {
  // make the rest of the page accessible again:
  $("#dp-container").removeAttr('aria-hidden');
  $("#skipnav").removeAttr('aria-hidden');
}

///////////////////////////////
//////////////////////////// //
///////////////////////// // //
// UTILITY-LIKE THINGS // // //
///////////////////////// // //
//////////////////////////// //
///////////////////////////////
function isOdd(num) {
  return num % 2;
}

function moveOneMonth(currentDate, dir) {
  var button = (dir === 'next')
      ? $('.ui-datepicker-next')[0]
      : $('.ui-datepicker-prev')[0];

  if (!button) {
    return;
  }

  var ENABLED_SELECTOR = '#ui-datepicker-div tbody td:not(.ui-state-disabled)';
  var $currentCells = $(ENABLED_SELECTOR);
  var currentIdx = $.inArray(currentDate.parentNode, $currentCells);

  button.click();
  setTimeout(function () {
    updateHeaderElements();

    var $newCells = $(ENABLED_SELECTOR);
    var newTd = $newCells[currentIdx];
    var newAnchor = newTd && $(newTd).find('a')[0];

    while (!newAnchor) {
      currentIdx--;
      newTd = $newCells[currentIdx];
      newAnchor = newTd && $(newTd).find('a')[0];
    }

    setHighlightState(newAnchor, $('#ui-datepicker-div')[0]);
    newAnchor.focus();

  }, 0);

}

function handleYearSelect() {

}

function handleNextClicks(e) {
  if (e) e.preventDefault();
  setTimeout(function () {
    updateHeaderElements();
    prepHighlightState();
    if ($(".ui-datepicker-next").hasClass("ui-state-disabled")) {
      $('.ui-datepicker-prev').focus();
    } else $('.ui-datepicker-next').focus();
    $(".ui-datepicker-current").hide();
  }, 10);
}

function handlePrevClicks(e) {
  if (e) e.preventDefault();
  setTimeout(function () {
    updateHeaderElements();
    prepHighlightState();
    if ($('.ui-datepicker-prev').hasClass("ui-state-disabled")) {
      $('.ui-datepicker-next').focus();
    } else $('.ui-datepicker-prev').focus();
    $(".ui-datepicker-current").hide();
  }, 10);
}

function previousDay(dateLink) {
  var container = document.getElementById('ui-datepicker-div');
  if (!dateLink) {
    return;
  }
  var td = $(dateLink).closest('td');
  if (!td) {
    return;
  }

  var prevTd = $(td).prev(),
      prevDateLink = $('a.ui-state-default', prevTd)[0];

  if (prevTd && prevDateLink) {
    setHighlightState(prevDateLink, container);
    prevDateLink.focus();
  } else {
    handlePrevious(dateLink);
  }
}


function handlePrevious(target) {
  var container = document.getElementById('ui-datepicker-div');
  if (!target) {
    return;
  }
  var currentRow = $(target).closest('tr');
  if (!currentRow) {
    return;
  }
  var previousRow = $(currentRow).prev();

  if (!previousRow || previousRow.length === 0) {
    // there is not previous row, so we go to previous month...
    previousMonth();
  } else {
    var prevRowDates = $('td a.ui-state-default', previousRow);
    var prevRowDate = prevRowDates[prevRowDates.length - 1];

    if (prevRowDate) {
      setTimeout(function () {
        setHighlightState(prevRowDate, container);
        prevRowDate.focus();
      }, 0);
    }
  }
}

function previousMonth() {
  var prevLink = $('.ui-datepicker-prev')[0];
  var container = document.getElementById('ui-datepicker-div');
  prevLink.click();
  // focus last day of new month
  setTimeout(function () {
    var trs = $('tr', container),
        lastRowTdLinks = $('td a.ui-state-default', trs[trs.length - 1]),
        lastDate = lastRowTdLinks[lastRowTdLinks.length - 1];

    // updating the cached header elements
    updateHeaderElements();

    setHighlightState(lastDate, container);
    lastDate.focus();

  }, 0);
}

///////////////// NEXT /////////////////
/**
 * Handles right arrow key navigation
 * @param  {HTMLElement} dateLink The target of the keyboard event
 */
function nextDay(dateLink) {
  var container = document.getElementById('ui-datepicker-div');
  if (!dateLink) {
    return;
  }
  var td = $(dateLink).closest('td');
  if (!td) {
    return;
  }
  var nextTd = $(td).next(),
      nextDateLink = $('a.ui-state-default', nextTd)[0];

  if (nextTd && nextDateLink) {
    setHighlightState(nextDateLink, container);
    nextDateLink.focus(); // the next day (same row)
  } else {
    handleNext(dateLink);
  }
}

function handleNext(target) {
  var container = document.getElementById('ui-datepicker-div');
  if (!target) {
    return;
  }
  var currentRow = $(target).closest('tr'),
      nextRow = $(currentRow).next();

  if (!nextRow || nextRow.length === 0) {
    nextMonth();
  } else {
    var nextRowFirstDate = $('a.ui-state-default', nextRow)[0];
    if (nextRowFirstDate) {
      setHighlightState(nextRowFirstDate, container);
      nextRowFirstDate.focus();
    }
  }
}

function nextMonth() {
  nextMon = $('.ui-datepicker-next')[0];
  var container = document.getElementById('ui-datepicker-div');
  nextMon.click();
  // focus the first day of the new month
  setTimeout(function () {
    // updating the cached header elements
    updateHeaderElements();

    var firstDate = $('a.ui-state-default', container)[0];
    setHighlightState(firstDate, container);
    firstDate.focus();
  }, 0);
}

/////////// UP ///////////
/**
 * Handle the up arrow navigation through dates
 * @param  {HTMLElement} target   The target of the keyboard event (day)
 * @param  {HTMLElement} cont     The calendar container
 * @param  {HTMLElement} prevLink Link to navigate to previous month
 */
function upHandler(target, cont, prevLink) {
  prevLink = $('.ui-datepicker-prev')[0];
  var rowContext = $(target).closest('tr');
  if (!rowContext) {
    return;
  }
  var rowTds = $('td', rowContext),
      rowLinks = $('a.ui-state-default', rowContext),
      targetIndex = $.inArray(target, rowLinks),
      prevRow = $(rowContext).prev(),
      prevRowTds = $('td', prevRow),
      parallel = prevRowTds[targetIndex],
      linkCheck = $('a.ui-state-default', parallel)[0];

  if (prevRow && parallel && linkCheck) {
    // there is a previous row, a td at the same index
    // of the target AND theres a link in that td
    setHighlightState(linkCheck, cont);
    linkCheck.focus();
  } else {
    // we're either on the first row of a month, or we're on the
    // second and there is not a date link directly above the target
    prevLink.click();
    setTimeout(function () {
      // updating the cached header elements
      updateHeaderElements();
      var newRows = $('tr', cont),
          lastRow = newRows[newRows.length - 1],
          lastRowTds = $('td', lastRow),
          tdParallelIndex = $.inArray(target.parentNode, rowTds),
          newParallel = lastRowTds[tdParallelIndex],
          newCheck = $('a.ui-state-default', newParallel)[0];

      if (lastRow && newParallel && newCheck) {
        setHighlightState(newCheck, cont);
        newCheck.focus();
      } else {
        // theres no date link on the last week (row) of the new month
        // meaning its an empty cell, so we'll try the 2nd to last week
        var secondLastRow = newRows[newRows.length - 2],
            secondTds = $('td', secondLastRow),
            targetTd = secondTds[tdParallelIndex],
            linkCheck = $('a.ui-state-default', targetTd)[0];

        if (linkCheck) {
          setHighlightState(linkCheck, cont);
          linkCheck.focus();
        }

      }
    }, 0);
  }
}

//////////////// DOWN ////////////////
/**
 * Handles down arrow navigation through dates in calendar
 * @param  {HTMLElement} target   The target of the keyboard event (day)
 * @param  {HTMLElement} cont     The calendar container
 * @param  {HTMLElement} nextLink Link to navigate to next month
 */
function downHandler(target, cont, nextLink) {
  nextLink = $('.ui-datepicker-next')[0];
  var targetRow = $(target).closest('tr');
  if (!targetRow) {
    return;
  }
  var targetCells = $('td', targetRow),
      cellIndex = $.inArray(target.parentNode, targetCells), // the td (parent of target) index
      nextRow = $(targetRow).next(),
      nextRowCells = $('td', nextRow),
      nextWeekTd = nextRowCells[cellIndex],
      nextWeekCheck = $('a.ui-state-default', nextWeekTd)[0];

  if (nextRow && nextWeekTd && nextWeekCheck) {
    // theres a next row, a TD at the same index of `target`,
    // and theres an anchor within that td
    setHighlightState(nextWeekCheck, cont);
    nextWeekCheck.focus();
  } else {
    nextLink.click();

    setTimeout(function () {
      // updating the cached header elements
      updateHeaderElements();

      var nextMonthTrs = $('tbody tr', cont),
          firstTds = $('td', nextMonthTrs[0]),
          firstParallel = firstTds[cellIndex],
          firstCheck = $('a.ui-state-default', firstParallel)[0];

      if (firstParallel && firstCheck) {
        setHighlightState(firstCheck, cont);
        firstCheck.focus();
      } else {
        // lets try the second row b/c we didnt find a
        // date link in the first row at the target's index
        var secondRow = nextMonthTrs[1],
            secondTds = $('td', secondRow),
            secondRowTd = secondTds[cellIndex],
            secondCheck = $('a.ui-state-default', secondRowTd)[0];

        if (secondRow && secondCheck) {
          setHighlightState(secondCheck, cont);
          secondCheck.focus();
        }
      }
    }, 0);
  }
}


function onCalendarHide() {
  closeCalendar();
}

// add an aria-label to the date link indicating the currently focused date
// (formatted identically to the required format: mm/dd/yyyy)
function monthDayYearText() {
  var cleanUps = $('.amaze-date');

  $(cleanUps).each(function (clean) {
    clean.parentNode.removeChild(clean);
  });

  var datePickDiv = document.getElementById('ui-datepicker-div');
  // in case we find no datepick div
  if (!datePickDiv) {
    return;
  }

  var dates = $('a.ui-state-default', datePickDiv);
  $(dates).attr('role', 'button').on('keydown', function (e) {
    if (e.which === 32) {
      e.preventDefault();
      e.target.click();
      setTimeout(function () {
        closeCalendar();
      }, 100);
    }
  });
  $(dates).each(function (index, date) {
    var currentRow = $(date).closest('tr'),
        currentTds = $('td', currentRow),
        currentIndex = $.inArray(date.parentNode, currentTds),
        headThs = $('thead tr th', datePickDiv),
        dayIndex = headThs[currentIndex],
        daySpan = $('span', dayIndex)[0],
        monthName = $('.ui-datepicker-month', datePickDiv)[0].innerHTML,
        year = $('.ui-datepicker-year option[selected="selected"]').text(),
        number = date.innerHTML;

    if (!daySpan || !monthName || !number || !year) {
      return;
    }

    // AT Reads: {month} {date} {year} {day}
    // "December 18 2014 Thursday"
    var dateText = daySpan.title + ', ' + monthName + ' ' + date.innerHTML + ", " + year;
    // AT Reads: {date(number)} {name of day} {name of month} {year(number)}
    // var dateText = date.innerHTML + ' ' + daySpan.title + ' ' + monthName + ' ' + year;
    // add an aria-label to the date link reading out the currently focused date
    date.setAttribute('aria-label', dateText);
  });
}



// update the cached header elements because we're in a new month or year
function updateHeaderElements() {
  var context = document.getElementById('ui-datepicker-div');
  if (!context) {
    return;
  }


  prev = $('.ui-datepicker-prev', context)[0];
  next = $('.ui-datepicker-next', context)[0];

  //make them click/focus - able
  next.href = 'javascript:void(0)';
  prev.href = 'javascript:void(0)';

  next.setAttribute('role', 'button');
  prev.setAttribute('role', 'button');
  appendOffscreenMonthText(next);
  appendOffscreenMonthText(prev);

  var nextData = $._data($(".ui-datepicker-next").get(0), 'events');
  var prevData = $._data($(".ui-datepicker-prev").get(0), 'events');

  var nextOnClickQuantity = nextData ? nextData.click : 0;
  var prevOnClickQuantity = prevData ? prevData.click : 0;
  if (nextOnClickQuantity.length < 1) {
    $(next).on('click', handleNextClicks);
  }
  if (prevOnClickQuantity.length < 1) {
    $(prev).on('click', handlePrevClicks);
  }

  remapTable();

  // add month day year text
  monthDayYearText();
}


function prepHighlightState() {
  var highlight;
  var cage = document.getElementById('ui-datepicker-div');
  highlight = $('.ui-state-highlight', cage)[0] ||
      $('.ui-state-default', cage)[0];
  if (highlight && cage) {
    setHighlightState(highlight, cage);
  }
}

// Set the highlighted class to date elements, when focus is received
function setHighlightState(newHighlight, container) {
  var prevHighlight = getCurrentDate(container);
  // remove the highlight state from previously
  // highlighted date and add it to our newly active date
  $(prevHighlight).removeClass('ui-state-highlight');
  $(newHighlight).addClass('ui-state-highlight');
}


// grabs the current date based on the highlight class
function getCurrentDate(container) {
  return $('.ui-state-highlight', container)[0];
}

/**
 * Appends logical next/prev month text to the buttons
 * - ex: Next Month, January 2015
 *       Previous Month, November 2014
 */
function appendOffscreenMonthText(button) {
  var buttonText;
  var isNext = $(button).hasClass('ui-datepicker-next');
  var months = [
    'january', 'february',
    'march', 'april',
    'may', 'june', 'july',
    'august', 'september',
    'october',
    'november', 'december'
  ];

  var currentMonth = $('.ui-datepicker-title .ui-datepicker-month').text().toLowerCase();
  var monthIndex = $.inArray(currentMonth.toLowerCase(), months);
  var adjacentIndex = (isNext) ? monthIndex + 1 : monthIndex - 1;
  var currentYear = $('.ui-datepicker-title .ui-datepicker-year option[selected="selected"]').text().toLowerCase();
  if (isNext && currentMonth === 'december') {
    currentYear = parseInt(currentYear, 10) + 1;
    adjacentIndex = 0;
  } else if (!isNext && currentMonth === 'january') {
    currentYear = parseInt(currentYear, 10) - 1;
    adjacentIndex = months.length - 1;
  }

  buttonText = (isNext)
      ? 'Next Month, ' + firstToCap(months[adjacentIndex]) + " " + currentYear
      : 'Previous Month, ' + firstToCap(months[adjacentIndex]) + " " + currentYear;

  $(button).find('.ui-icon').html(buttonText);

}

// Returns the string with the first letter capitalized
function firstToCap(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

Backbone.Epoxy.binding.addHandler("datepickerBirthdateMobile", {
  init: function( $element, value, bindings, context ) {
    $element.attr('maxlength', 12);
    $element.attr('placeholder', "MM-DD-YYYY");

    $element.focusin(function() {
      $element.val(global.bookedby.helpers.dateFormatFocus($element.val(), 'MMMM D, YYYY', 'MM-DD-YYYY', true, true));
    });
    $element.focusout(function() {
      $element.val(global.bookedby.helpers.dateFormatFocus($element.val(), 'MM-DD-YYYY', 'MMMM D, YYYY', true, false));
    });
  },

  get: function( $element, value, event ) {
    return global.bookedby.helpers.birthdateInternalFormat($element.val());
  },

  set: function( $element, value ) {
    var dateRaw = (''+value).replace(/\+1/g, '').replace(/\D/g, '');
    var dateFormatted = '';

    for (var i = 0; (i < dateRaw.length); i++) {
      dateFormatted += dateRaw[i];
      if ((dateFormatted.length == 2) || (dateFormatted.length == 5)) {
        dateFormatted += '-';
      }
    }
    dateFormatted = dateFormatted.substr(0, 10);
    $element.val(global.bookedby.helpers.birthdateFormat(dateFormatted));
  }
});

Backbone.Epoxy.binding.addHandler("datepickerRange", {
  init: function( $element, value, bindings, context ) {
    $element.datepicker({
      //minDate: 0,
      dateFormat: 'MM d, yy',
      constrainInput: true
    });
    $element.addClass('has-datepicker');
    $('#ui-datepicker-div').css('display', 'none'); //Hack to fix empty datepicker div displaying on init
  },


  get: function( $element, value, event ) {
    return $element.datepicker('getDate');
  },

  set: function( $element, value ) {
    $element.datepicker('setDate', value);

    // making both datepickers aware of each others values and maintain valid range available for selection
    if(this.$el.hasClass('form-dateTo')) {
      $('.form-dateFrom').datepicker('option', 'maxDate', value);

    } else if(this.$el.hasClass('form-dateFrom')) {
      $('.form-dateTo').datepicker('option', 'minDate', value);
    }
  },

  clean: function() {
    if (this.$el.hasClass('has-datepicker')) {
      try {
        this.$el.datepicker('destroy');
        this.$el.removeClass('has-datepicker');
      } catch (ex) {}
    }
  }
});


/**
 * Handler for phone numbers inputs. Formats input as (123) 123-1234 and returns to model in format: +11231231234
 */
Backbone.Epoxy.binding.addHandler("phoneNumberValue", {

  init: function( $element, value, bindings, context ) {
    $element.attr('maxlength', 12);
    $element.attr('placeholder', "");
  },

  get: function( $element, value, event ) {
    return global.bookedby.helpers.phoneInternalFormat($element.val());
  },

  set: function( $element, value ) {
    var formattedValue = global.bookedby.helpers.phoneFormat(value);
    $element.val(formattedValue);
  }
});

/**
 * Handler for phone numbers texts. Formats text to the format (123) 123-1234.
 */
Backbone.Epoxy.binding.addHandler("phoneNumberText", {
  set: function( $element, value ) {
    var formattedValue = global.bookedby.helpers.phoneFormat(value);
    $element.text(formattedValue);
  }
});

Backbone.Epoxy.binding.addHandler("date", {

  init: function( $element, value, bindings, context ) {
    $element.attr('maxlength', 10);
    $element.attr('placeholder', "YYYY-MM-DD");
  },

  get: function( $element, value, event ) {
    return $element.val();
  },

  set: function( $element, value ) {
    var numbers = (""+value).replace(/\+1/g, '').replace(/\D/g, '');
    var dateString = '';

    for (var i = 0; (i < numbers.length); i++) {
      dateString += numbers[i];
      if ((dateString.length == 4) || (dateString.length == 7)) {
        dateString += '-';
      }
    }
    dateString = dateString.substr(0, 11);
    $element.val(dateString);
  }
});

var ratingStarsBinding = function(addClickListener) {

  return {
    init: function( $element, value, bindings, context ) {

      var model = bindings.$model();
      $element.empty();
      for (var i = 1; i <= 5; i++) {
        var star = $('<i>', {
          'data-idx': i,
          'class': 'fa fa-star'
        });

        if (addClickListener) {

          star.click(_.bind(function(ev) {
            var newRating = ev.target.getAttribute('data-idx');
            model.set('rating', newRating);
          }, this));

          star.hover(_.bind(function(ev) {
            var hoverIndex = ev.target.getAttribute('data-idx');
            //model.set('rating', newRating);
            var stars = $element.find('i');
            for (var i = 1; i <= 5; i++) {
              if (i <= hoverIndex) {
                //$(stars[i-1]).removeClass('fa-star-o');
                $(stars[i-1]).addClass('active');
              } else {
                $(stars[i-1]).removeClass('active');
                //$(stars[i-1]).addClass('fa-star-o');
              }
            }
          }, this), _.bind(function(ev) {
            var prevValue = model.get('rating');
            var stars = $element.find('i');
            for (var i = 1; i <= 5; i++) {
              if (i <= prevValue) {
                //$(stars[i-1]).removeClass('fa-star-o');
                $(stars[i-1]).addClass('active');
              } else {
                $(stars[i-1]).removeClass('active');
                //$(stars[i-1]).addClass('fa-star-o');
              }
            }
          }, this));

        }

        $element.append(star);
      }
    },

    get: function( $element, value, event ) {},

    set: function($element, value) {
      var stars = $element.find('i');
      for (var i = 1; i <= 5; i++) {
        if (i <= value) {
          //$(stars[i-1]).removeClass('fa-star-o');
          $(stars[i-1]).addClass('active');
        } else {
          $(stars[i-1]).removeClass('active');
          //$(stars[i-1]).addClass('fa-star-o');
        }
      }
    }
  }
};

var ratingStarsStackedBinding = function() {
  return {
    init: function( $element, value, bindings, context ) {
      $element.empty();

      var wrapper = $('<div>', {
        'class': 'o-partial-stars o-partial-stars--binding js-rating-stars'
      });

      for (var i = 1; i <= 5; i++) {
        var star = $('<i>', { 'class': 'fa fa-star fa-stack-1x is-inactive' });
        var halfStar = $('<i>', { 'class': 'fa fa-star-half fa-stack-1x is-inactive' });

        var closure = $('<div>', {
          'class': 'fa fa-stack',
          'data-idx': i
        });

        closure.append(star);
        closure.append(halfStar);
        wrapper.append(closure);
      }

      $element.append(wrapper);
    },

    get: function( $element, value, event ) {},

    set: function($element, value) {
      var closures = $element.find('.js-rating-stars').find('div');

      for (var i = 1; i <= 5; i++) {
        var stars = $(closures[i-1]).find('i');
        if (value == i - 0.5) {
          $(stars[0]).addClass('is-inactive');
          $(stars[0]).removeClass('is-active');
          $(stars[1]).addClass('is-active');
          $(stars[1]).removeClass('is-inactive');
        } else if (value < i) {
          $(stars[0]).addClass('is-inactive');
          $(stars[0]).removeClass('is-active');
          $(stars[1]).addClass('is-inactive');
          $(stars[1]).removeClass('is-active');
        } else {
          $(stars[0]).addClass('is-active');
          $(stars[0]).removeClass('is-inactive');
          $(stars[1]).addClass('is-active');
          $(stars[1]).removeClass('is-inactive');
        }
      }
    }
  }
};

Backbone.Epoxy.binding.addHandler("ratingStars", ratingStarsBinding(true));
Backbone.Epoxy.binding.addHandler("ratingStarsValue", ratingStarsBinding(false));
Backbone.Epoxy.binding.addHandler("ratingStarsStackedValue", ratingStarsStackedBinding());

/**
 * Not currently used anywhere. Remove this comment if you use it.
 * Left here in case it becomes handy.Just moting that it can be fully modified without worrying.
 */
Backbone.Epoxy.binding.addHandler("ellipsisText", {

  init: function( $element, value, bindings, context ) {
    //$element.dotdotdot();
  },

  get: function( $element, value, event ) {
    return $element.text();
  },

  set: function( $element, value ) {

    $element.text(value);
    $element.dotdotdot({
      watch: true
    });

  }
});

Backbone.Epoxy.binding.addFilter('timeToDuration', function(time) {
  return global.bookedby.helpers.timeToDuration(time).concatTime;
});

Backbone.Epoxy.binding.addFilter('dateFormat', global.bookedby.helpers.dateFormat);

Backbone.Epoxy.binding.addFilter('textTruncate', global.bookedby.helpers.textTruncate);

Backbone.Epoxy.binding.addFilter('timeFormat', global.bookedby.helpers.timeFormat);

Backbone.Epoxy.binding.addFilter('phoneFormat', global.bookedby.helpers.phoneFormat);

Backbone.Epoxy.binding.addFilter('modelProp', function(model, property) {
  var result = (model == null) ? null : model.get(property);
  return (result == null) ? '' : result;
});

Backbone.Epoxy.binding.addFilter('priceFormat', function(price) {
  return bookedby.helpers.formatCurrency(price);
});

Backbone.Epoxy.binding.addFilter('priceRange', function(minPrice, maxPrice) {
  return bookedby.helpers.priceRange([minPrice, maxPrice]);
});

Backbone.Epoxy.binding.addFilter('storePhotoById', function(photoId, imageType) {
  return bookedby.helpers.storePhotoById(photoId, imageType);
});

Backbone.Epoxy.binding.addFilter('employeePhoto', function(employee, imageType) {

  if (_.isNumber(employee)) {
    employee = {
      photoId: employee
    }
  }

  var employeeData = (employee instanceof Backbone.Model) ? employee.attributes : employee;
  return bookedby.helpers.employeePhoto(employeeData, imageType);
});

Backbone.Epoxy.binding.addFilter('storePhoto', function(store, imageType) {

  if (_.isNumber(store)) {
    store = {
      photoId: store
    }
  }

  var storeData = (store instanceof Backbone.Model) ? store.attributes : store;
  return bookedby.helpers.storePhoto(storeData, imageType);
});

Backbone.Epoxy.binding.addFilter('reviewPhoto', function(review, imageType) {

  if (_.isNumber(review)) {
    review = {
      photoId: review
    }
  }

  var reviewData = (review instanceof Backbone.Model) ? review.attributes : review;
  return bookedby.helpers.reviewPhoto(reviewData, imageType);
});


module.exports = {};
